/** API route map: URLS.Controller.EmployeeBenefitLifeEvent */
export const EmployeeBenefitLifeEvent = {
      Name: 'EmployeeBenefitLifeEvent/',
      GetEmployeeBenefitLifeEventPaginated: 'get-employee-benefit-life-event-paginated',
      AddEmployeeBenefitLifeEvent: 'add-employee-benefit-life-event',
      UpdateEmployeeBenefitLifeEvent: 'update-employee-benefit-life-event',
      GetEmployeeBenefitLifeEventById: 'get-benefit-life-event-by-id',
      DeleteEmployeeBenefitLifeEventById: 'delete-benefit-life-event-by-id',
};
